<template>
    <div :class="phoneClass || 'header-container'">
        <div class="header-wrapper">
            <div class="header-left">
                <div class="logo-band">
                    <img src="../../assets/logo.png" class="logo">
                    <!-- <span class="band-name">{{$t('title')}}</span> -->
                </div>
                <slot></slot>
            </div>
            <slot name="center"></slot>
            <div class="header-right">
                <!-- <el-select v-if="!phoneClass" v-model="lang" placeholder="请选择" @change="languageChange" class="lang-select"> -->
                <el-select v-model="lang" placeholder="请选择" @change="languageChange" class="lang-select">
                    <template slot="prefix">
                        <img src="../../assets/img/btn/icon-lang.png" class="icon-lang">
                    </template>
                    <el-option
                        v-for="lang in langList"
                        :key="lang.id"
                        :label="lang.name"
                        :value="lang.value">
                    </el-option>
                </el-select>
                <div class="user-avatar-wrapper" v-if="(user && username) && (!hiddenUser.includes($route.path))" >
                    <el-popover placement="bottom-end"
                                trigger="click"
                                :visible-arrow="false"
                                popper-class="user-action-popper">
                        <div class="user-action-menu">
                            <span class="inner-span" @click="openEditPasswordDialog">{{ $t('user.eidt') }}</span>
                            <span class="inner-span" @click="openSwitchAccountDialog">{{ $t('header.switch_account') }}</span>
                            <span class="inner-span" @click="logout">{{ $t('header.logout') }}</span>
                        </div>
                        <div class="user-avatar" slot="reference">
                            <img src="/avatar.png" class="avatar">
                            <span class="name">{{username}}</span>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
        <el-dialog width="450px" :title="$t('user.eidt')" :visible.sync="showEditPassword" class="detail-change password-dialog-wrapper">
            <div class="dialog password-dialog">
                <div class="dialog-form password-dialog-form">
                    <div class="form-item">
                        <div class="form-label">原密码:</div>
                        <div class="form-value">
                            <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码"></el-input>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">{{$t('user.new_password')}}:</div>
                        <div class="form-value">
                            <el-input v-model="passwordForm.password" type="password" :placeholder="$t('retrieve.new_password')"></el-input>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">{{$t('retrieve.new_password_again')}}:</div>
                        <div class="form-value">
                            <el-input v-model="passwordForm.confirmPassword" type="password" :placeholder="$t('retrieve.new_password_again')"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-bottom password-dialog-bottom">
                <el-button class="cancel" @click="closeEditPasswordDialog">{{ $t('message.cancel') }}</el-button>
                <el-button type="primary" class="confirm" @click="confirmChangePassword">{{ $t('message.determine') }}</el-button>
            </div>
        </el-dialog>
        <el-dialog width="420px" :title="$t('header.switch_account')" :visible.sync="showSwitchAccountDialog" class="switch-account-dialog-wrapper">
            <div class="switch-account-dialog">
                <div class="switch-account-section">
                    <div class="switch-account-section-header">
                        <span class="switch-account-section-title">{{ $t('header.switchable_account') }}</span>
                    </div>
                    <div class="switch-account-list">
                        <div class="switch-account-item switch-account-item-current" v-if="currentAccountItem && currentAccountItem.account">
                            <div class="switch-account-info">
                                <div class="switch-account-top">
                                    <p class="switch-account-name">{{ currentAccountItem.user_name || currentAccountItem.account }}</p>
                                    <span class="switch-account-tag">{{ $t('header.current_account') }}</span>
                                </div>
                                <p class="switch-account-value">{{ currentAccountItem.account }}</p>
                            </div>
                        </div>
                        <div class="switch-account-empty" v-if="switchAccountList.length === 0">{{ $t('header.no_other_account') }}</div>
                        <div class="switch-account-item" v-for="item in switchAccountList" :key="item.account">
                            <div class="switch-account-info">
                                <p class="switch-account-name">{{ item.user_name || item.account }}</p>
                                <p class="switch-account-value">{{ item.account }}</p>
                            </div>
                            <div class="switch-account-action-group">
                                <el-button size="mini" type="primary" plain @click="switchAccount(item)">{{ $t('header.switch_action') }}</el-button>
                                <el-button size="mini" type="text" class="switch-account-delete-button" @click="removeRecentAccount(item.account)">{{ $t('header.delete_account') }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="switch-account-footer">
                    <el-button class="switch-account-back-button" @click="goLoginNewAccount">{{ $t('header.switch_other_account') }}</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Core from 'core/core'
import {refresh} from "core/winSize"
export default {
    data() {
      return {
            phoneClass: '',
           langList: [
                { id: 1, name: '简体', value: 'zh' },       
                { id: 2, name: '繁體', value: 'tw' },       
                { id: 3, name: 'English', value: 'en' },    
                { id: 4, name: '日本語', value: 'ja' },     
                { id: 5, name: '한국어', value: 'ko' },     
           ],
           lang: 'zh',
           username: '',
           user: '',
           hiddenUser: [],
           showEditPassword: false,
           passwordForm: {
               oldPassword: '',
               password: '',
               confirmPassword: ''
           },
           showSwitchAccountDialog: false,
           switchAccountList: [],
           currentAccountItem: {}
      };
    },
	created() {
		refresh(this,'phoneClass-phoneHeader');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-phoneHeader');
			},10)
		};
	},
    mounted(){
        this.initUserInfo();
        this.getCurrentLang();
        this.getHiddenUserList();
    },
    methods:{
        getHiddenUserList() {
            this.hiddenUser = [];
            this.$router.options.routes.map(path => {
                path.hiddenUser ? this.hiddenUser.push(path.path): ''
            })
            // console.log(this.hiddenUser,this.$route.path)
        },
        initUserInfo(){
            let user = Core.Data.getUser();
            if(user) {
                this.syncCurrentUserInfo(user);
            }
        },
        // 同步当前账号对应的用户信息，确保头部展示与本地缓存一致
        syncCurrentUserInfo(user) {
            this.user = user;
            this.username = user.email || user.nickname || user.username || user.phone || "未知";
            this.avatar = user.avatar;
        },
        getCurrentLang() {
            let lang = Core.Data.getLang();
            this.lang = lang
        },
        languageChange(val) {
            const supportedLangs = ['zh', 'en', 'ja', 'ko', 'tw'];
            const defaultLang = 'zh';
            const lang = supportedLangs.includes(val) ? val : defaultLang;
            i18n.locale = lang;
            Core.Data.setLang(lang); 

            // 先移除所有语言类，再添加当前类
            document.body.classList.remove(...supportedLangs.map(l => `lang-${l}`));
            document.body.classList.add(`lang-${lang}`);
            location.reload();
        },
        openEditPasswordDialog() {
            this.passwordForm.oldPassword = '';
            this.passwordForm.password = '';
            this.passwordForm.confirmPassword = '';
            this.showEditPassword = true;
        },
        closeEditPasswordDialog() {
            this.showEditPassword = false;
        },
        confirmChangePassword() {
            if (!this.passwordForm.oldPassword) {
                this.$message.error('请输入原密码');
                return;
            }
            if (!this.passwordForm.password) {
                this.$message.error('请输入密码');
                return;
            }
            if (!this.isStrongPassword(this.passwordForm.password)) {
                this.$message.error('密码至少8位，且必须包含大小写字母、数字和特殊字符');
                return;
            }
            if (!this.passwordForm.confirmPassword) {
                this.$message.error('请再次输入密码');
                return;
            }
            if (this.passwordForm.password !== this.passwordForm.confirmPassword) {
                this.$message.error('两次密码输入不一致，请重新输入');
                return;
            }
            Core.Api.User.updatePasswordWithOld(this.passwordForm.oldPassword, this.passwordForm.password).then(() => {
                this.$message.success('修改成功');
                this.closeEditPasswordDialog();
            }).catch(() => {
                this.$message.error('修改失败');
            })
        },
        // 校验密码强度：至少8位，包含大小写字母、数字和特殊字符
        isStrongPassword(password) {
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(password)
        },
        logout() {
            let currentAccount = Core.Data.getCurrentAccount();
            Core.Api.User.logout().then(()=>{
                if (currentAccount) {
                    Core.Data.removeRecentAccount(currentAccount);
                }
                this.$router.push('/login');
                Core.Data.clearAuthData();
            })
        },
        openSwitchAccountDialog() {
            let currentAccount = Core.Data.getCurrentAccount();
            let recentAccountList = Core.Data.getRecentAccountList();
            this.currentAccountItem = recentAccountList.find(item => item && item.account === currentAccount) || {
                account: currentAccount,
                user_name: this.username || currentAccount
            };
            this.switchAccountList = recentAccountList.filter(item => item && item.account !== currentAccount);
            this.showSwitchAccountDialog = true;
        },
        switchAccount(item) {
            if (!item || !item.account) {
                return;
            }
            let result = Core.Data.switchRecentAccount(item.account);
            if (!result) {
                this.$message.warning(this.$t('header.account_session_expired'));
                return;
            }
            this.showSwitchAccountDialog = false;
            let user = Core.Data.getUser();
            if (user) {
                this.syncCurrentUserInfo(user);
            }
            this.reloadPageByUser(user);
        },
        removeRecentAccount(account) {
            Core.Data.removeRecentAccount(account);
            this.openSwitchAccountDialog();
        },
        goLoginNewAccount() {
            this.showSwitchAccountDialog = false;
            this.$router.push('/login');
        },
        reloadPageByUser(user) {
            let targetPath = user && user.role === 2 ? '/storage' : '/home';
            window.location.href = `${window.location.pathname}#${targetPath}`;
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../assets/style/mixin";
.header-container {
    .header-wrapper {
        // padding: 10px 0;
        // height: 90px;
        // min-width: 100vw;
        // background-color: #2F3A54;
        background: #0F58D6;

        @include flex-sb;
        .header-left {
            padding-left: 40px;
            display: inline-flex;
            height: 100%;
            align-items: center;
            .logo-band {
                // width: 272px;
                display: inline-block;
                // padding-right: 20px;
                vertical-align: middle;
                padding-right: 20px;
                .logo {
                    width: 111px;
                    height: 26px;
                    vertical-align: middle;
                }
                .band-name {
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 26px;
                    margin-left: 10px;
                    font-weight: 500;
                    vertical-align: middle;
                }
            }
        }
        .header-right {

            .icon-lang {
                width: 20px;
                height: 20px;
            }
            .lang-select {
                margin-right: 20px;
                vertical-align: middle;
            }
            .user-avatar-wrapper {
                padding-left: 20px;
                display: inline-block;
                padding-right: 40px;
                border-left: 1px solid rgba($color: #000000, $alpha: .3);
                .user-avatar {
                    cursor: pointer;
                    .avatar {
                        width: 34px;
                        height: 34px;
                        vertical-align: middle;
                    }
                    .name {
                        font-size: 14px;
                        color: #FFFFFF;
                        vertical-align: middle;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
    .header-container {
        .lang-select {
            border-radius: 20px;
            .el-input__inner {
                // min-width: 88px;
                width: auto;
                max-width: 118px;
                border-radius: 20px;
                width: auto;
                background-color: rgba($color: #000000, $alpha: .1);
                color: #fff;
                height: 36px;
                padding-left: 34px !important;
                border-color: rgba($color: #FFFFFF, $alpha: .1)
            }
            .el-input__prefix {
                display: inline-flex;
                left: 8px;
                align-items: center;
            }
            .el-select-dropdown.el-popper {
                border-radius: 20px;
            }
        }
    }

    .phoneClass-phoneHeader {
        .header-wrapper {
            background: #0F58D6;
            min-height: 60px;
            display: flex;
            align-items: center!important;
            justify-content: space-between;
            .header-left {
                display: inline-flex;
                /*height: 100%;*/
                position: relative;
                align-items: center;
                width: 30%;
                margin-left: 10px;
                //margin-top: 10px;
                .logo-band {
                    img {
                        vertical-align: -webkit-baseline-middle;
                        min-width: 60px;
                        min-height: 25px;
                        height: 25px;
                        /*height: 30px;*/
                    }
                }
                .slot-content {
                    border-left: 1px solid rgba(0, 0, 0, 0.3);
                    min-width: 100px;
                    color: #99BEFF;
                    font-size: 20px;
                    margin-left: 10px;
                    font-weight: 500;
                }
            }
            .header-right {
                text-align: right;
                position: relative;
                width: 70%;
                .el-select {
                    width: 100px;
                    .el-input {
                        .el-input__inner {
                            font-size: 10px;
                            height: 25px;
                            background-color: rgba(0, 0, 0, 0.1);
                            border-radius: 20px;
                            color: white;
                            padding-left: 34px;
                        }
                        .el-input__prefix{
                            top: 5px;
                            margin-left: 5px;
                            img {
                                width: 15px;
                                height: 15px;
                            }
                        }
                        .el-input__suffix {
                            color: #C0C4CC;
                        }
                    }
                }
                .user-avatar-wrapper {
                    min-width: 100px;
                    padding-left: 10px;
                    margin-left: 10px;
                    border-left: 1px solid rgba(0, 0, 0, 0.3);
                    text-align: center;
                    .user-avatar {
                        .avatar {
                            vertical-align: bottom;

                        }
                        .name {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
    }

    .inner-span{
        display: inline-block;
        width: 100px;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
        padding: 8px 0;
    }
    .user-action-popper {
        padding: 0 !important;
        border: none !important;
        border-radius: 8px !important;
        overflow: hidden !important;
        box-shadow: 0 8px 24px rgba(31, 41, 55, 0.16) !important;
        margin-top: 12px !important;
    }
    .user-action-menu {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        background: #FFFFFF;
        border-radius: 8px;
        .inner-span {
            width: 140px;
            line-height: 44px;
            padding: 0;
            font-size: 14px;
            color: #3D4757;
            text-align: center;
            transition: background 0.2s ease, color 0.2s ease;
        }
        .inner-span:hover {
            background: #F5F8FF;
            color: #0F58D6;
        }
        .inner-span + .inner-span {
            border-top: 1px solid #EEF2F7;
        }
    }
    .switch-account-dialog-wrapper {
        .el-dialog {
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 20px 50px rgba(15, 23, 42, 0.24);
        }
        .el-dialog__header {
            padding: 20px 24px 16px;
            border-bottom: 1px solid #E8EEF6;
            background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
        }
        .el-dialog__title {
            font-size: 20px;
            color: #334155;
            font-weight: 600;
            line-height: 28px;
        }
        .el-dialog__headerbtn {
            top: 22px;
            right: 22px;
        }
        .el-dialog__headerbtn .el-dialog__close {
            font-size: 20px;
            color: #B6C0CF;
        }
        .el-dialog__body {
            padding: 18px;
            background: linear-gradient(180deg, #F8FAFC 0%, #F3F7FC 100%);
        }
    }
    .password-dialog-wrapper {
        .el-dialog {
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 20px 50px rgba(15, 23, 42, 0.24);
        }
        .el-dialog__header {
            padding: 20px 28px 16px;
            border-bottom: 1px solid #E8EEF6;
            background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
        }
        .el-dialog__title {
            font-size: 20px;
            color: #334155;
            font-weight: 600;
            line-height: 28px;
        }
        .el-dialog__headerbtn {
            top: 22px;
            right: 22px;
        }
        .el-dialog__headerbtn .el-dialog__close {
            font-size: 20px;
            color: #B6C0CF;
        }
        .el-dialog__body {
            padding: 24px 28px 22px;
            background: linear-gradient(180deg, #F8FAFC 0%, #F3F7FC 100%);
        }
    }
    .password-dialog {
        padding: 0;
    }
    .password-dialog-form {
        padding: 20px;
        background: #FFFFFF;
        border: 1px solid #E7EEF8;
        border-radius: 14px;
        box-shadow: 0 10px 24px rgba(15, 88, 214, 0.06);
        .form-item {
            display: block;
            margin-bottom: 18px;
        }
        .form-item:last-child {
            margin-bottom: 0;
        }
        .form-label {
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 20px;
            color: #475569;
            font-weight: 500;
        }
        .form-value {
            width: 100%;
        }
        .el-input__inner {
            height: 44px;
            line-height: 44px;
            border-radius: 10px;
            border-color: #D7E2F0;
            background: #F8FAFC;
            color: #1E293B;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .el-input__inner:focus {
            border-color: #0F58D6;
            box-shadow: 0 0 0 3px rgba(15, 88, 214, 0.12);
            background: #FFFFFF;
        }
        .el-input__inner::placeholder {
            color: #A0AEC0;
        }
    }
    .password-dialog-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 12px;
        margin-top: 18px;
        padding: 18px 20px 16px;
        box-sizing: border-box;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(232, 240, 252, 0.95) 100%);
        border: 1px solid #DCE7F6;
        border-radius: 16px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
        .el-button {
            min-width: 108px;
            height: 44px;
            border-radius: 14px;
            font-size: 14px;
            font-weight: 500;
            padding: 0 24px;
            transition: all 0.2s ease;
        }
        .cancel {
            border-color: #D7E2F0;
            color: #475569;
            background: #FFFFFF;
            margin-right: 0;
            box-shadow: 0 6px 14px rgba(148, 163, 184, 0.10);
        }
        .cancel:hover {
            border-color: #BFD2F3;
            color: #0F58D6;
            background: #F8FBFF;
            transform: translateY(-1px);
        }
        .confirm {
            margin: 0;
            box-shadow: 0 8px 18px rgba(15, 88, 214, 0.24);
            background: linear-gradient(135deg, #2A6DF6 0%, #0F58D6 100%);
            border-color: #0F58D6;
        }
        .confirm:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 24px rgba(15, 88, 214, 0.28);
        }
    }
    .switch-account-dialog {
        .switch-account-section {
            background: #FFFFFF;
            border: 1px solid #E7EEF8;
            border-radius: 14px;
            padding: 16px;
            box-shadow: 0 10px 24px rgba(15, 88, 214, 0.06);
        }
        .switch-account-section-header {
            margin-bottom: 12px;
        }
        .switch-account-section-title {
            display: inline-block;
            font-size: 14px;
            color: #64748B;
            font-weight: 500;
        }
        .switch-account-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }
    .switch-account-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 14px;
        border-radius: 12px;
        background: #FFFFFF;
        border: 1px solid #E7EEF8;
        transition: all 0.2s ease;
    }
    .switch-account-item:hover {
        background: #F8FBFF;
        border-color: #CFE0FF;
        box-shadow: 0 8px 18px rgba(15, 88, 214, 0.08);
    }
    .switch-account-item-current {
        background: linear-gradient(180deg, #F6FAFF 0%, #EEF5FF 100%);
        border-color: #CFE0FF;
    }
    .switch-account-info {
        flex: 1;
        min-width: 0;
    }
    .switch-account-top {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
    }
    .switch-account-name {
        font-size: 15px;
        line-height: 22px;
        color: #3D4757;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .switch-account-value {
        font-size: 12px;
        line-height: 18px;
        color: #98A2B3;
        word-break: break-all;
    }
    .switch-account-tag {
        padding: 2px 8px;
        border-radius: 999px;
        background: #DCEBFF;
        color: #0F58D6;
        font-size: 12px;
        line-height: 18px;
        flex-shrink: 0;
    }
    .switch-account-action-group {
        display: flex;
        align-items: center;
        margin-left: 12px;
        white-space: nowrap;
        flex-shrink: 0;
    }
    .switch-account-delete-button {
        margin-left: 8px;
    }
    .switch-account-empty {
        padding: 24px 0;
        text-align: center;
        font-size: 13px;
        color: #98A2B3;
        background: #FFFFFF;
        border-radius: 12px;
        border: 1px dashed #D9E4F5;
    }
    .switch-account-footer {
        margin-top: 14px;
    }
    .switch-account-back-button {
        width: 100%;
        height: 42px;
        border-radius: 10px;
        border-color: #D8E2F0;
        color: #475569;
        background: #FFFFFF;
        font-weight: 500;
    }
    .switch-account-back-button:hover {
        color: #0F58D6;
        border-color: #B9D4FF;
        background: #F8FBFF;
    }
</style>
